import { Paper, Typography, Box } from "@mui/material";

export default function StatsCard({ label, value }) {
    return (
        <Paper
            sx={{
                p: 2.5,
                borderRadius: 3,
                flex: 1,
                minWidth: 220,
                boxShadow: "0 3px 8px rgba(0,0,0,0.07)",
            }}
        >
            <Typography sx={{ fontSize: 14, opacity: 0.7 }}>{label}</Typography>
            <Typography sx={{ fontSize: 32, fontWeight: 700, mt: 1 }}>
                {value}
            </Typography>
        </Paper>
    );
}
